import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
`;

export const Header = styled.header`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 2rem;
  border-bottom: 1px solid #3d3d3d;
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
`;

export const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1rem;
  column-gap: 2rem;
  margin-bottom: 0.7rem;

  input {
    width: 100%;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ClientDataContainer = styled.div`
  > div {
    margin-bottom: 1rem;
  }
`;

export const AlertCheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0.9rem;
  padding: 0.9rem;
  border-radius: 6px;
  background-color: var(--black-100);

  .checkbox-root {
    background-color: var(--white);
    width: 1.7rem;
    height: 1.7rem;
    padding: 0.3rem;
    border: 3px solid var(--primary);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background-color: var(--primary);
    }

    &:focus {
      background-color: var(--primary);
    }

    &:checked {
      background-color: var(--primary);
    }
  }

  .checkbox-indicator {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 0.9rem;
      height: 0.9rem;

      path {
        stroke: var(--black-100);
        stroke-width: 0.4rem;
      }
    }
  }
`;

export const CheckboxLabel = styled.label`
  font-size: 0.9rem;
  font-family: Inter, sans-serif;
  cursor: pointer;
  margin-left: 0.9rem;
`;

export const Map = styled.div`
  width: 100%;

  > div {
    margin-bottom: 0px !important;
  }

  > label {
    &:first-of-type {
      margin-bottom: 0.2rem;
    }
  }
`;


export const Test = styled.div`
  margin-top:16px
`;
